import styled from '@emotion/styled';
import ContentCard from '../content-card';
import { SadaContentCardChildren } from '../content-card/styles';

export const SadaDocumentsCard = styled(ContentCard)`
  ${SadaContentCardChildren.toString()} {
    padding: 0;
  }
`;
